module.exports = __webpack_public_path__ + "article.97649177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/feeds/article.png
// module id = 1516
// module chunks = 0